module.exports = __webpack_public_path__ + "img/random_goods.846307b8.png";